import {
	type Control,
	Controller,
	type FieldPathByValue,
	type FieldValues,
} from "react-hook-form";
import {
	BoxedSliderField,
	type BoxedSliderFieldProps,
} from "web_myplann/Inspiration/Components/BoxedSliderField";

type Props<TForm extends FieldValues> = Omit<
	BoxedSliderFieldProps,
	"value" | "onChange"
> & {
	control: Control<TForm>;
	name: FieldPathByValue<TForm, number>;
};

export const BoxedSliderFormField = <TForm extends FieldValues>({
	control,
	name,
	...rest
}: Props<TForm>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange } }) => (
			<BoxedSliderField {...rest} value={Number(value)} onChange={onChange} />
		)}
	/>
);
